import React from 'react';
import { storeConfig } from '../../config/config';
import './storeDetails.scss';
import '../message/message.scss';

type storeDetailProps = {
    store: any,
    isHostDevice: boolean
}

const StoreDetails = ({store, isHostDevice}: storeDetailProps) => {
    const [timeStr1, timeStr2] = store.data.store_trading_hours || ['', ''];
    const getDirection = () => {
        window.open(`${storeConfig.GOOGLE_MAP_API_DIRECTION_URL}${store.data.division}, ${store.data.addressLine1}, ${store.data.suburb}`, '_blank');
    }

    return (
        <div className='store'>
            <div className='store__location'>
                <div className='store__title'>Dan Murphy's <span className='store__suburb'>{store.data.suburb.toLowerCase()}</span></div>
                <div className='store__address'>{store.data.addressLine1}</div>
                <div className='store__address'><span className='store__suburb'>{store.data.suburb.toLowerCase()}</span> {store.data.postcode}</div>
            </div>
            <div className={'store__hours ' + (isHostDevice && 'store__hours--device')} >
               <div className='store__date'>
                   <span><b>{timeStr1}</b> {timeStr2 && '-'} {timeStr2}</span>
               </div>
            </div>
            <div className='message__text--qr store__direction' onClick={getDirection}>Get directions</div>
        </div>
    );
}

export {
    StoreDetails
}